import { render, staticRenderFns } from "./IconPaperAirplaneSolid.vue?vue&type=template&id=7ae49495"
import script from "./IconPaperAirplaneSolid.vue?vue&type=script&lang=js"
export * from "./IconPaperAirplaneSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports